import { render, staticRenderFns } from "./CustomerOrOrder.vue?vue&type=template&id=1ca1d5e2&scoped=true&"
import script from "./CustomerOrOrder.vue?vue&type=script&lang=js&"
export * from "./CustomerOrOrder.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOrOrder.vue?vue&type=style&index=0&id=1ca1d5e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca1d5e2",
  null
  
)

export default component.exports